import React from "react";
import {
  Box,
  Typography,
  CardContent,
  LinearProgress,
  Divider,
} from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { CustomerStatsDto } from "../../../shared/dtos/customer/CustomerStatsDto";

interface CustomerWidgetProps {
  data: CustomerStatsDto;
}

const CustomerWidget: React.FC<CustomerWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("CUSTOMER");
  const Icon = meta.icon;

  const safeTotal = data.totalCustomers || 1;
  const activePercentage = (data.activeCustomers / safeTotal) * 100;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        {/* standard Widget Header */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        {/* Primary Metric */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Customers
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {data.totalCustomers}
          </Typography>
        </Box>

        {/* Active Status Progress */}
        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="body2" sx={{ color: "success.main" }}>
              Active Now
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {data.activeCustomers}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={activePercentage}
            color="success"
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Secondary Metric */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Active Ratio
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "info.main" }}
          >
            {activePercentage.toFixed(1)}%
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default CustomerWidget;
